import { Tag } from 'src/app/models/tag';

export class TagGroup {
    tags: Tag[];
    groupName: string;

    constructor(name: string, tags: Tag[]) {
        this.groupName = name;
        this.tags = tags;
    }
}
